import Editor from "@monaco-editor/react";
import { Box } from "@mui/material";
import { useCodingLanguages } from "../../../context/CodingLanguageContext";
import { useState, useEffect } from "react";
import { capitalize } from "lodash-es";

const CodeEditor = ({ question,languageValues }) => {
  const { selectedLanguage, code, handleEditorChange, setCode } =
    useCodingLanguages();

  useEffect(() => {
    setCode(
      question?.code_language.find((l) => l.language === selectedLanguage)
        ?.template,
    );
  }, [selectedLanguage]);

  return (
    <div style={{ height: "100%", width: "100%" }}>
      {" "}
      <Editor
        height="100%"
        // defaultLanguage="cpp"
        language={languageValues[selectedLanguage]}
        theme="vs"
        value={code}
        onChange={handleEditorChange}
        options={{
          minimap: { enabled: false },
          fontSize: 14,
          automaticLayout: true,
          padding: { top: 10 },
          suggestOnTriggerCharacters: false,
          quickSuggestions: false,
          formatOnPaste: false,
          formatOnType: false,
          acceptSuggestionOnEnter: "off",
        }}
      />
    </div>
  );
};

export default CodeEditor;
